import { ActivatedRoute } from "@angular/router";
import { Component, OnInit, Input } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { ConsumeRestApiService } from "../../services/consume-rest-api.service";
import { TealiumUtagService } from "../../services/utag.service";
import { environment } from "../../../environments/environment";
import { LogInStatusService } from "src/app/services/loginStatus.service";
import { SpinnerService } from "../../services/spinner.service";
import { SessionService, ALLOWED_HOSTS } from "../session-dialog/session.service";

const TEALIUM_ACCOUNT = environment.tealium.account;
const TEALIUM_PROFILE = environment.tealium.profile;
const TEALIUM_ENV = environment.tealium.env;
const UTAG_FILTER_LIST = [
  "login_status",
  "loyalty_balance",
  "loyalty_id",
  "loyalty_id_temp",
  "loyalty_tier",
  "loyalty_tier_temp",
  "server",
  "site_country",
  "site_indicator",
  "site_language",
  "tealium_environment",
  "tealium_profile",
  "time_stamp",
  "trueclient_ip",
  "partner_code_info",
  "pnr_booked_date",
];

@Component({
    selector: "app-flightchangehistory",
    templateUrl: "./flightchangehistory.component.html",
    styleUrls: ["./flightchangehistory.component.scss"],
    standalone: false
})
export class FlightchangehistoryComponent implements OnInit {
  utagData: any = {};
  changeInfo: any = {};
  updateFlights: any = {};
  originalFlights: any = {};
  airTravelers: any = {};
  recordLocator: string = "";
  locale: string = "en_US";
  timeFormat: string = "";
  errorMessage: any = "";
  pageLoadFlag = false;
  onSuccess = false;
  onError = false;
  isCollapsed = false;
  expandCollapseIcon = "icon-expand";
  accessToken: any;
  accountDetails: any;
  loginStatus: string;

  constructor(
    private _cookieService: CookieService,
    private route: ActivatedRoute,
    private _seatReaccomNotifService: ConsumeRestApiService,
    private _tealium: TealiumUtagService,
    private logInStatusService: LogInStatusService,
    private spinnerService: SpinnerService,
    private sessionService: SessionService
  ) {
    this._tealium.setConfig({
      account: TEALIUM_ACCOUNT,
      profile: TEALIUM_PROFILE,
      environment: TEALIUM_ENV,
    });
  }

  expandCollapse(): void {
    if (this.isCollapsed) {
      this.expandCollapseIcon = "icon-expand";
    } else {
      this.expandCollapseIcon = "icon-collapse";
    }
    this.isCollapsed = !this.isCollapsed;
  }

  getChangeHistoryData() {
    this._seatReaccomNotifService.getData(this.locale).subscribe(
      (data) => this.handlePageData(data),
      (error) => this.handleErrorData(error)
    );
  }

  getSessionLocale() {
    const sessionLocale = this._cookieService.get("sessionLocale");
    this.locale =
      sessionLocale !== undefined && sessionLocale !== ""
        ? sessionLocale
        : this.locale;
  }

  handlePageData(data: any) {
    this.changeInfo = data.changeInfo;
    this.updateFlights = data.updatedFlights;
    this.originalFlights = data.originalFlights;
    this.airTravelers = data.airTravelers;
    this.timeFormat = data.timeFormat;
    this.pageLoadFlag = true;
    this.onSuccess = true;
    const recordLocatorList = "";
    this.recordLocator = sessionStorage.getItem("recordLocator_data");
    const sessionRecordLocatorList =
      sessionStorage.getItem("recordLocatorList");
    if (sessionRecordLocatorList != null && sessionRecordLocatorList != "") {
      const sessionRecordLocator = sessionRecordLocatorList.concat(
        "," + this.recordLocator
      );
      sessionStorage.setItem("recordLocatorList", sessionRecordLocator);
    } else {
      const recordLocatorValue = recordLocatorList.concat(this.recordLocator);
      sessionStorage.setItem("recordLocatorList", recordLocatorValue);
    }

    const success_utag_data = {
      page_name: "Seats Reaccom",
      channel: "View Res",
      page_action: "View Changes",
      pnr: this.recordLocator,
      alert_message: data.changeInfo.tripUpdateKeys,
    };
    this.reportAnalytics(success_utag_data);
    this.spinnerService.hideSpinner();
  }

  handleErrorData(data: any) {
    this.pageLoadFlag = true;
    this.onError = true;
    const error_utag_data = {
      page_name: "Seats Reaccom",
      channel: "View Res",
      page_action: "View Changes",
      error_id: "1464",
    };
    this.reportAnalytics(error_utag_data);
    this.spinnerService.hideSpinner();
  }

  ngOnInit() {
    this.spinnerService.showSpinner();
    ALLOWED_HOSTS.includes(location.hostname) && this.sessionService.startSession();
    this.getUserInformation();
    this.getSessionLocale();
    this.getChangeHistoryData();
  }

  reportAnalytics(data: any) {
    const final_utag_data = JSON.parse("{}");
    const strUtag = sessionStorage.getItem("utag_data_cloud");
    //sessionStorage.removeItem('utag_data_cloud');
    this.utagData =
      strUtag !== undefined && strUtag !== "" ? JSON.parse(strUtag) : {};
    if (this.utagData && this.utagData["login_status"] === "Logged_out") {
      //UNABLE TO RETRIVE SOFT LOGIN DETAILS FROM HEADER SO IGNORING IT CURRENTLY.
      if (
        this.accessToken &&
        this.accessToken.status === LogInStatusService.SECURED
      ) {
        this.utagData["login_status"] = "Logged_in";
        this.utagData["loyalty_balance"] = this.accountDetails.awardMiles.value;
        this.utagData["loyalty_id"] = this.accountDetails.aadvantageNumber;
        this.utagData["loyalty_id_temp"] = this.accountDetails.aadvantageNumber;
        this.utagData["loyalty_tier"] = this.accountDetails.tierLevel;
        this.utagData["loyalty_tier_temp"] = this.accountDetails.tierLevel;
      }
    }
    for (let index = 0; index < UTAG_FILTER_LIST.length; index++) {
      if (
        this.utagData != null &&
        this.utagData.hasOwnProperty(UTAG_FILTER_LIST[index])
      ) {
        final_utag_data[UTAG_FILTER_LIST[index]] =
          this.utagData[UTAG_FILTER_LIST[index]];
      }
    }
    this.utagData = Object.assign({}, final_utag_data, data);
    this._tealium.view(this.utagData);
  }

  getUserInformation() {
    this.logInStatusService.accessLevel.subscribe(
      (response) => {
        if (response) {
          this.accessToken = response as any;
        }
        if (
          this.accessToken &&
          this.accessToken.status === LogInStatusService.SECURED
        ) {
          this.logInStatusService.isUserLoggedIn().subscribe(
            (response) => {
              if (response === undefined) {
                return;
              }
              const statusCode = response.status;
              const codes = [301, 302, 307, 308];
              if (codes.indexOf(statusCode) < 0) {
                this.accountDetails = response as any;
                return;
              }
            },
            (error) => {}
          );
        }
      },
      (error) => {}
    );
  }
}
